function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.087 1.7C.934 2.853.934 4.708.934 8.42c0 3.71 0 5.566 1.153 6.719C3.24 16.29 5.095 16.29 8.806 16.29c3.71 0 5.566 0 6.718-1.153 1.153-1.153 1.153-3.008 1.153-6.719 0-3.71 0-5.566-1.153-6.719C14.372.547 12.516.547 8.806.547c-3.711 0-5.566 0-6.719 1.153zm8.096 5.145c0 .326.264.59.59.59h.543L9.732 9.02a.197.197 0 01-.278 0L8.205 7.771a1.378 1.378 0 00-1.948 0L4.453 9.576a.59.59 0 10.834.835l1.805-1.805a.197.197 0 01.279 0l1.248 1.248c.538.538 1.41.538 1.948 0L12.15 8.27v.543a.59.59 0 001.18 0V6.845a.59.59 0 00-.59-.59h-1.967a.59.59 0 00-.59.59z",
  fill: "#fff"
});

function SvgIconInvestPotentialSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _ref);
}

export default SvgIconInvestPotentialSmall;